export enum TemplateSMSEmail {
	EMAIL_FGTS_VALID = "EMAIL_FGTS_VALID",
	SMS_ANTFGTS_STRANS = "SMS_ANTFGTS_STRANS",
	SMS_ANTFGTS_STATUS = "SMS_ANTFGTS_STATUS",
}
